import ETC_AXIOS from '../api/etc.axios'
// util
import Util from '@/utils/util'
import APP from '../config/app.config'
import ETC from '../config/etc.config'

export default {
  // 招行还款
  getZHRepay(data) {
    // return ETC_AXIOS.post('/bank/cmb/repayment/net-pay', data)
    return ETC_AXIOS.post(APP.TOLL_URL + '/etctollsapi/tolls/mini/order/cmb/repayment', data, {headers: {'Content-Type': 'multipart/form-data', 'X-APP-ID': '1'}})
  },
  // 招行通行记录
  getZHThrough() {
    // return ETC_AXIOS.post('/bank/cmb/repayment/get-list', {uid: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.ETC_UID)})
    return ETC_AXIOS.post(APP.TOLL_URL + '/etctollsapi/tolls/mini/order/cmb/repayment/list', {uid: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.ETC_UID)}, {headers: {'X-APP-ID': '1'}})
  },
  // 招行校验欠款
  getZHRepayStatus() {
    // return ETC_AXIOS.post('/bank/cmb/repayment/check', {uid: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.ETC_UID)})
    return ETC_AXIOS.post(APP.TOLL_URL + '/etctollsapi/tolls/mini/order/cmb/repayment/check', {uid: localStorage.getItem(ETC.LOCAL_STORAGE_KEY.ETC_UID)})
  },
  // 获取上次识别信息
  lastApplyData () {
    return ETC_AXIOS.post('/apply/reuse-last-apply').then(res => {
      const result = Util.deepAssign(res.ocr_result, {idcard_back: {}, idcard_front: {}, vehicle_front: {}, vehicle_back: {}})
      let idCard = Object.assign({}, result.idcard_front, result.idcard_back)
      if (idCard.number) {
        idCard.number = idCard.number.replace(/(\S{14})(\S+)/g, '$1 $2').replace(/(\S{6})(\S+)/g, '$1 $2')
      }
      // 对上次结果进行返显处理
      let vehicle = Object.assign({}, result.vehicle_back, result.vehicle_front)
      vehicle.plate_no = (result.vehicle_front.plate_no || result.vehicle_back.plate_no || '').toUpperCase()
      // if (res.address && res.address.send_phone) {
      //   res.address.send_phone = res.address.send_phone.replace(/ /g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3')
      // }
      let images = {
        idcard_front: {status: '', url: res.img_url.idCard.idcard_front},
        idcard_back: {status: '', url: res.img_url.idCard.idcard_back},
        idcard_hold: {status: '', url: res.img_url.idCard.idcard_hold},
        vehicle_front: {status: '', url: res.img_url.license.vehicle_front},
        vehicle_back: {status: '', url: res.img_url.license.vehicle_back},
        vehicle_car: {status: '', url: res.img_url.license.vehicle_car}
      }
      // 通过有效时间判断上次是否为高并发状态
      images.idcard_front.status = images.idcard_front.url ? (res.ocr_success.idcard_front ? 2 : 4) : 0
      images.idcard_back.status = images.idcard_back.url ? (res.ocr_success.idcard_back ? 2 : 4) : 0
      images.idcard_hold.status = images.idcard_hold.url ? 2 : 0
      images.vehicle_front.status = images.vehicle_front.url ? (res.ocr_success.vehicle_front ? 2 : 4) : 0
      images.vehicle_back.status = images.vehicle_back.url ? (res.ocr_success.vehicle_back ? 2 : 4) : 0
      images.vehicle_car.status = images.vehicle_car.url ? 2 : 0
      if (Util.isNull(idCard)) return {validate_result: res.validate_result}
      return {idCard, vehicle, address: res.address, images: images, validate_result: res.validate_result}
    })
  },
  uploadPhoto (data) {
    return ETC_AXIOS.post('/apply/upload', data, {headers: {'Content-Type': 'multipart/form-data', timeout: 60000}})
  },
  // 修正身份证 OCR 识别结果
  modifyIDCard (data) {
    return ETC_AXIOS.post('/apply/modify-id-card-ocr', data)
  },
  // 身份证验真
  validateIDCard () {
    return ETC_AXIOS.post('/apply/validate-id-card')
  },
  // checkPlateNo (data) {
  //   return ETC_AXIOS.post('/apply/check-plate-can-apply', data)
  // },
  // 修正行驶证 OCR 识别结果
  modifyLicense (data) {
    return ETC_AXIOS.post('/apply/modify-vehicle-license-ocr', data)
  },
  // 行驶证验真
  validateLicense () {
    return ETC_AXIOS.post('/apply/validate-vehicle-license')
  },
  // 提交所有图片, 获取订单号
  submitPhotos (data) {
    return ETC_AXIOS.post('/apply/submit-photos', data)
  },
  // 发送验证码
  sendCode (data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/apply/send-code', data)
  },
  // 获取用户是否需要支付设备费等其他信息
  getPaymentInfo (data) {
    return ETC_AXIOS.post('/apply/purchase-obu', {order_sn: data.order_sn})
    // return ETC_AXIOS.post(data.cardType === 1 ? '/apply/purchase-obu' : '/apply/precharge', {order_sn: data.order_sn})
  },
  // 用户主动取消订单
  cancelOrder (data) {
    return ETC_AXIOS.post('/apply/cancel-order', data)
  },
  // 支付完成页获取车牌号
  getPlateNo(data) {
    return ETC_AXIOS.post('/apply/get-plateno', data)
  },
  checkBind(data) {
    return ETC_AXIOS.post('/auth/check-bind', data)
  },
  declareReceived(data) { // 办卡进度确认收货
    return ETC_AXIOS.post('/apply/declare-received', data)
  },
  resetStatus(data) { // apply again
    return ETC_AXIOS.post('/apply/reset-status', data)
  },
  throughRec(data) { // 通行记录
    return ETC_AXIOS.post('/profile/toll-records', data)
  }
}
